import { View } from './view'

export const SocialsV2 = View
